import { Fragment } from "react"

import { LoanProgramsList, PageHeader } from "../../common/ui"
import {
  useFindDefaultPricingSetsQuery,
  useFindPricingSetsQuery
} from "../../redux/queries"
import { useAppSelector } from "../../common/hooks"
import { selectUserDetails } from "../../redux/slices/auth"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"

type Props = {
  title?: string
}

const LoanPrograms: React.FC<Props> = ({ title = "Loan programs" }) => {
  const userDetails = useAppSelector(selectUserDetails)

  const { data: pricingSets = [], isLoading: isPricingSetsLoading } =
    useFindPricingSetsQuery(
      {
        owner: userDetails?.id ?? ""
      },
      { refetchOnMountOrArgChange: true }
    )

  const { data: defaultPricingSet, isLoading: isDefaultPricingSetLoading } =
    useFindDefaultPricingSetsQuery(
      {
        loid: userDetails?.id ?? ""
      },
      { refetchOnMountOrArgChange: true }
    )

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["loan-programs"]}>
      <Fragment>
        <PageHeader className="p-6 pb-0 bg-white" title={title}>
          {/* TODO: Remove comment after adding functionality */}
          {/* <PrimaryBtn onClick={}>
            <Plus size={16} />
            &nbsp;New Loan Program
          </PrimaryBtn> */}
        </PageHeader>

        <LoanProgramsList
          pricingSets={pricingSets}
          isLoading={isPricingSetsLoading || isDefaultPricingSetLoading}
          defaultPricingSetId={defaultPricingSet?.id ?? ""}
        />
      </Fragment>
    </RequireRole>
  )
}

export default LoanPrograms
